import {ParcelGeometry} from "./map/parcel-geometry";

export class Flurstueck{

  constructor() {
  }
  id: string;
  number: string;
  geometry?: ParcelGeometry;
}
